import {get} from '../utils'

export default host => (section = "", withTimestamp = false, forEdit = false) => {
  return get(`${host}/home/elements/metadata${forEdit ? "/edit" : ""}?include=translations${section ? `&section_id=${section}` : ""}`, null, withTimestamp)
    .then(response => response.json())
    .then(json => json.data)
}
